import { Box } from '@mui/material';
import { COPY } from '../../copy';
import { useLayoutStyles } from '../../layouts/layout-context';
import type { BillingPeriod } from './plans-block';

interface BillingToggleProps {
  period: BillingPeriod;
  onChange: (period: BillingPeriod) => void;
  savingsPercent: number | null;
}

export const BillingToggle = ({ period, onChange, savingsPercent }: BillingToggleProps) => {
  const s = useLayoutStyles('plans');
  const state = (value: BillingPeriod) => (period === value ? 'on' : 'off');

  return (
    <Box sx={s.billing}>
      <Box sx={s.billingGroup} role="group" aria-label="Billing period">
        <Box
          component="button"
          type="button"
          aria-pressed={period === 'monthly'}
          onClick={() => onChange('monthly')}
          sx={s.billingButton[state('monthly')]}
        >
          {COPY.monthly}
        </Box>
        <Box
          component="button"
          type="button"
          aria-pressed={period === 'annual'}
          onClick={() => onChange('annual')}
          sx={s.billingButton[state('annual')]}
        >
          {COPY.annual}
          {savingsPercent !== null ? (
            <Box component="span" sx={s.saveChip[state('annual')]}>
              {COPY.saveChip(savingsPercent)}
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};
